import { render, staticRenderFns } from "./PesquisaItensApoio.vue?vue&type=template&id=4e880ec4&scoped=true"
import script from "./PesquisaItensApoio.vue?vue&type=script&lang=js"
export * from "./PesquisaItensApoio.vue?vue&type=script&lang=js"
import style0 from "./PesquisaItensApoio.vue?vue&type=style&index=0&id=4e880ec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e880ec4",
  null
  
)

export default component.exports